import { createContext } from 'react';

export type FavoritesContextValue = {
  favorites: string[];
  isFavorite: (id: string) => boolean;
  toggleFavorite: (id: string) => void;
  canAdd: boolean;
};

export const FavoritesContext = createContext<FavoritesContextValue | null>(null);
